import {
    getAllCustomerOrder,
    createOrderByCustomer,
    getACutomerOrder,
    updateCustomerOrder,
    deleteCustomerOrder,
} from '../../services/customer/customerService'
import { errorHandler } from '../../utils/errorHandler'
import { notification } from '../notification/notificationActions'
import { customerTypes } from './customerTypes'
import { userTypes } from '../user/userTypes'

//create order by customer
export const createOrderByCustomerAction = (body, closeModal) => async (
    dispatch,
    getState
) => {
    const { allCustomerOrder } = getState().customer
    dispatch({
        type: customerTypes.CREATE_ORDER_BY_CUSTOMER_START,
    })
    try {
        const { data } = await createOrderByCustomer(body)
        const createOrderByCostomer = [...allCustomerOrder, data?.data]

        dispatch({
            type: customerTypes.CREATE_ORDER_BY_CUSTOMER_SUCCESS,
            payload: createOrderByCostomer,
        })

        dispatch(
            notification({
                message: 'سفارش شما با موفقیت ثبت شد',
                variant: 'success',
            })
        )

        closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            customerTypes.CREATE_ORDER_BY_CUSTOMER_FAILED,
            error,
            allCustomerOrder
        )
    }
    dispatch({
        type: customerTypes.CREATE_ORDER_BY_CUSTOMER_END,
    })
}

//get all customer order
export const getAllCustomerOrderAction = body => async dispatch => {
    dispatch({
        type: customerTypes.GET_ALL_CUSTOMER_ORDER_START,
    })
    try {
        const { data } = await getAllCustomerOrder(body)
        dispatch({
            type: customerTypes.GET_ALL_CUSTOMER_ORDER_SUCCESS,
            payload: data?.data,
            meta: data?.meta,
        })
        dispatch({
            type: userTypes.UPDATE_IS_NEW_ORDER_TO_FALSE_START,
        })
    } catch (error) {
        errorHandler(
            dispatch,
            customerTypes.GET_ALL_CUSTOMER_ORDER_FAILED,
            error
        )
    }
    dispatch({
        type: customerTypes.GET_ALL_CUSTOMER_ORDER_END,
    })
}

//get a customer order
export const getACutomerOrderAction = id => async dispatch => {
    dispatch({
        type: customerTypes.GET_A_CUSTOMER_ORDER_START,
    })
    try {
        const { data } = await getACutomerOrder(id)
        dispatch({
            type: customerTypes.GET_A_CUSTOMER_ORDER_SUCCESS,
            payload: data?.data,
        })
    } catch (error) {
        errorHandler(dispatch, customerTypes.GET_A_CUSTOMER_ORDER_FAILED, error)
    }
    dispatch({
        type: customerTypes.GET_A_CUSTOMER_ORDER_END,
    })
}

//update customer order
export const updateCustomerOrderAction = (id, body, closeModal) => async (
    dispatch,
    getState
) => {
    const { allCustomerOrder } = getState().customer
    const index = allCustomerOrder.findIndex(
        selectedCustomerOrder => selectedCustomerOrder.id === id
    )

    dispatch({
        type: customerTypes.UPDATE_CUSTOMER_ORDER_START,
    })
    try {
        const { data } = await updateCustomerOrder(id, body)
        allCustomerOrder[index] = data?.data
        dispatch({
            type: customerTypes.UPDATE_CUSTOMER_ORDER_SUCCESS,
            payload: allCustomerOrder,
        })
        dispatch(
            notification({
                message: `سفارش شما به روز رسانی شد`,
                variant: 'success',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            customerTypes.UPDATE_CUSTOMER_ORDER_FAILED,
            error,
            allCustomerOrder
        )
    }
    dispatch({
        type: customerTypes.UPDATE_CUSTOMER_ORDER_END,
    })
}

//delete customer order
export const deleteCustomerOrderAction = (id, closeModal) => async (
    dispatch,
    getState
) => {
    const { allCustomerOrder } = getState().customer
    const filteredCustomerOrder = allCustomerOrder.filter(
        order => order.id !== id
    )
    dispatch({
        type: customerTypes.DELETE_CUSTOMER_ORDER_START,
    })
    try {
        const { data } = await deleteCustomerOrder(id)
        dispatch({
            type: customerTypes.DELETE_CUSTOMER_ORDER_SUCCESS,
            payload: filteredCustomerOrder,
        })
        dispatch(
            notification({
                message: 'سفارش مورد نظر با موفقیت حذف شد',
                variant: 'success',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            customerTypes.DELETE_CUSTOMER_ORDER_FAILED,
            error,
            allCustomerOrder
        )
    }
    dispatch({
        type: customerTypes.DELETE_CUSTOMER_ORDER_END,
    })
}
